/**
 * 图层编辑节点数据模型（方案 4.7）
 * LayerDocument 随 node.data.layerDocument 持久化（与 DirectorNodeData.sceneData 同构）；
 * 缩略图存 node.data.thumbnailDataUrl（nodeData 侧，不进撤销快照）。
 */

export const LAYER_DOC_VERSION = 1;

export type LayerType = 'image' | 'text' | 'grid';
// V1 仅创建 'image'（宫格拼接「应用」后生成的亦是位图 image 层）；
// 'text'/'grid' 为后续版本数据兼容预留，本期无创建路径与渲染分支

export interface LayerTransform {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  flipX: boolean;
  flipY: boolean;
  opacity: number;
}

export interface ImageLayerSource {
  assetId?: string;
  url: string;
  naturalWidth: number;
  naturalHeight: number;
}

export interface LayerShadow {
  color: string;
  blur: number;
  offsetX: number;
  offsetY: number;
  opacity: number;
}

export interface LayerItem {
  id: string;
  name: string;
  type: LayerType;
  source: ImageLayerSource;
  transform: LayerTransform;
  locked: boolean;
  visible: boolean;
  /** 调色参数 { brightness, contrast, saturation }（4.6.8） */
  adjust?: Record<string, number>;
  /** 混合模式 → Canvas2D globalCompositeOperation，默认 'source-over'（4.6.8） */
  blendMode?: string;
  /** 投影（4.6.8），缺省 = 关闭 */
  shadow?: LayerShadow;
  createdAt: number;
}

export interface LayerBackground {
  type: 'transparent' | 'solid';
  color?: string;
}

export interface LayerDocument {
  version: number;
  ratio: string;
  canvasWidth: number;
  canvasHeight: number;
  background: LayerBackground;
  layers: LayerItem[];
}

export function createLayerDocument(ratio: string, width: number, height: number): LayerDocument {
  return {
    version: LAYER_DOC_VERSION,
    ratio,
    canvasWidth: width,
    canvasHeight: height,
    background: { type: 'transparent' },
    layers: [],
  };
}

/** 宫格拼接配置（4.4.3） */
export interface GridComposeConfig {
  rows: number;
  cols: number;
  ratio: string; // 'canvas' | '1:1' | ...
  gap: number; // px
  gapColor: string;
  placements: (string | null)[]; // 长度 rows*cols，存图层 id 或 null
}
